export default __webpack_public_path__ + "static/media/sampleImage.ed9752ba.jpg";